import {React , useState} from 'react'
import {
  Eye,
  EyeOff
} from "lucide-react"
import { useLanguage } from "../context/LanguageProvider";

export default function ToggleShowStats({showStatsValues,setShowStatsValues}) {
  const [isAnimating, setIsAnimating] = useState(false);
  const { locale } = useLanguage();
  return (
    <>
      <button
          onClick={() => {
              setIsAnimating(true);
              setShowStatsValues(!showStatsValues);
              setTimeout(() => setIsAnimating(false), 300);
          }} 
          role="switch"
          className={`
            relative w-14 h-7 rounded-full cursor-pointer outline-none
            transition-all duration-300 ease-out
            focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-accent
            border border-border bg-gray-200
            group
            ${showStatsValues 
              ? 'bg-gradient-to-r from-teal-500 to-emerald-300' 
              : 'bg-muted hover:bg-muted/80'
            }
          `}
        >
          {/* Animated thumb */}
          <div
            className={`
              absolute top-[1px] w-6 h-6 rounded-full bg-white shadow-md
              flex items-center justify-center
              transition-all duration-300 ease-out
              ${showStatsValues ? locale === "ar" ? 'translate-x-[-1.8rem]' : 'translate-x-7' : 'translate-x-0'}
            `}
          >
            <div
              className={`
                transition-all duration-300
                ${isAnimating ? 'scale-110' : 'scale-100'}
              `}
            >
              {showStatsValues ? (
                <EyeOff size={16} className="text-teal-500" strokeWidth={1.5} />
              ) : (
                <Eye size={16} className="text-muted-foreground dark:text-white" strokeWidth={1.5} />
              )}
            </div>
          </div>
        </button>
    </>
  )
}
